import React from 'react'

const CaretUpIcon = ({ className, size = 26, ...rest }) => {
    return (
        <svg {...rest} className={`${className} mx-1`} xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 26 26" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.1191 16.5191C18.8753 16.7628 18.5447 16.8997 18.2 16.8997C17.8553 16.8997 17.5247 16.7628 17.2809 16.5191L13 12.2382L8.7191 16.5191C8.47392 16.7559 8.14554 16.8869 7.80468 16.884C7.46382 16.881 7.13777 16.7443 6.89674 16.5033C6.65571 16.2622 6.51899 15.9362 6.51603 15.5953C6.51306 15.2545 6.6441 14.9261 6.8809 14.6809L12.0809 9.4809C12.3247 9.23719 12.6553 9.10028 13 9.10028C13.3447 9.10028 13.6753 9.23719 13.9191 9.4809L19.1191 14.6809C19.3628 14.9247 19.4997 15.2553 19.4997 15.6C19.4997 15.9447 19.3628 16.2753 19.1191 16.5191Z" fill="currentColor" />
        </svg>
    )
}

export default CaretUpIcon